import { components } from '@luxuryescapes/contract-public-offer'
type ContractSchema = components['schemas']
type LeHotelOffer = ContractSchema['leHotelOffer']
type LeTourOffer = ContractSchema['v1TourOffer']

const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24
const NEW_DEAL_MAX_DAYS_LIVE = 3
const NEW_DEAL_MIN_DAYS_TO_END = 4

export function isTier1Offer(dealTier?: string): boolean {
  if (!dealTier) {
    return false
  }

  // It uses word boundaries to ensure we match exactly tier 1, not tier 10/11/etc.
  const tierMatch = dealTier.toLowerCase().match(/\btier[\s-]*1\b/)

  return tierMatch !== null
}

function offerUrgencyLabelMap(offer: LeHotelOffer | LeTourOffer): Array<App.OfferUrgencyLabel> {
  /**
   * All urgency tags from public offer are no longer used except the lux plus general release,
   * the 'left' tag, and the 'new' tag
   */
  const tags: Array<App.OfferUrgencyLabel> = []

  // Check if offer is "new" - 1) Deal is Tier 1 AND 2) Deal is live for less than 3 days AND 2) More than 4 days until the deal ends
  if (isTier1Offer(offer.dealTier) && offer.schedules?.listVisibility?.start && offer.schedules?.listVisibility?.end) {
    const currentDate = new Date()
    const listVisibilityStart = new Date(offer.schedules.listVisibility.start)
    const daysSinceDealIsLive = Math.floor((currentDate.getTime() - listVisibilityStart.getTime()) / MILLISECONDS_PER_DAY)
    const dealEndDate = new Date(offer.schedules.listVisibility.end)
    const daysToDealEnd = Math.floor((dealEndDate.getTime() - currentDate.getTime()) / MILLISECONDS_PER_DAY)

    if (daysSinceDealIsLive >= 0 && daysSinceDealIsLive < NEW_DEAL_MAX_DAYS_LIVE && daysToDealEnd > NEW_DEAL_MIN_DAYS_TO_END) {
      tags.push({
        type: 'new',
        message: 'NEW',
      })
    }
  }

  const luxPlusTag = offer.tags.urgency.find(tag => tag.type === 'lux_plus_general_release')
  if (luxPlusTag) {
    const releaseStart = offer.schedules?.luxPlus?.start
    const releaseEnd = offer.schedules?.listVisibility?.start

    tags.push({
      start: releaseStart,
      end: releaseEnd,
      type: 'lux_plus_general_release',
      message: luxPlusTag.message ?? undefined,
    })
  }

  if (offer.schedules?.listVisibility) {
    tags.push({
      end: offer.schedules.listVisibility.end,
      type: 'left',
      message: undefined,
    })
  } else if (offer.schedules?.bookBy) {
    tags.push({
      end: offer.schedules.bookBy.end,
      type: 'left',
      message: undefined,
    })
  }

  return tags
}

export default offerUrgencyLabelMap
